/* PD - guides offerts a la place du cadeau (v2 du 04/10/2026, CRO_PLAN §11, validé ; v1 = test du 03/10).
   Source : tmp/pdx/giftless/v2/eb_src/pdeb.js (build.py). Charge UNIQUEMENT par product.ctl-eb / product.pdx-eb, et seulement
   si le snippet pdeb a juge la fiche eligible (classe html.pdeb, donnees #pdeb-data). Sinon : rien, la fiche reste la fiche normale.
   Le panier reste celui de buy-buttons-v2 (drapeaux __vs2FgDone / __vs2FgGifts=false poses par le snippet : ni pop-up cadeau ni cadeau) :
   ce script ne fait que (1) proposer l'option dans la pop-up \u00AB Add to cart \u00BB, (2) synchroniser les cases de l'option,
   (3) remettre le produit en 1re ligne du panier, (4) remplacer les dernieres mentions du cadeau par les guides. */
(function () {
  'use strict';
  if (window.__pdebJs) return;
  window.__pdebJs = 1;
  var html = document.documentElement;
  if (!html.classList.contains('pdeb')) return;
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var D = {};
  try { D = JSON.parse(q('#pdeb-data').textContent) || {}; } catch (e) { D = {}; }
  var A = D.addon && D.addon.vid ? D.addon : null;
  var N = +D.n || 0;
  var W = N === 1 ? 'guide' : 'guides';      /* v2 (04/10) : produits a un seul guide */
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function ph(name, props) { try { if (window.phCapture) window.phCapture(name, props || {}); } catch (e) {} }
  /* Test A/B pop-up d'option on / off (07/10 08:45 -> 10/10) TERMINE : pop-up gardee pour tous (validé 10/10 « garde popup » ;
     avec pop-up 4,00 % d'achat contre 3,48 %, +11 % de CA par visiteur). addon_pop = all_on ecrase l'ancien tirage garde dans le
     cookie PostHog (super-propriete) ; localStorage pd_addon_pop n'est plus lu. Apercu : ?addonpop=on|off (addon_pop = preview). */
  var POP = 'on';
  if (A) {
    var qp = (location.search.match(/[?&]addonpop=(on|off)/) || [])[1];
    var tag = qp ? 'preview' : 'all_on';
    if (qp) POP = qp;
    (function reg(t) {
      try { if (window.posthog && window.posthog.__loaded && window.posthog.register) { window.posthog.register({ addon_pop: tag }); return; } } catch (e) {}
      if (t < 30) setTimeout(function () { reg(t + 1); }, 500);
    })(0);
  }
  /* 10/10 : variantes de DESIGN de la pop-up (demande « A/B test popup : design »). APERCU SEULEMENT tant que le test n'est pas
     lancé : ?popd=a|b|c (gardé pour la visite). a = actuelle · b = récap de commande (produit choisi + option + guides + total)
     · c = bandeau compact en bas d'écran (image + prix, « No thanks » et « Add » côte à côte). Prop. design sur gift_addon_popup. */
  var PDD = 'a';
  try {
    var pq = (location.search.match(/[?&]popd=([abc])/) || [])[1];
    if (pq) sessionStorage.setItem('pd_popd', pq);
    PDD = sessionStorage.getItem('pd_popd') || 'a';
  } catch (e) {}
  if (!/^[abc]$/.test(PDD)) PDD = 'a';

  /* 1. Panier : l'option part AVANT le produit. Shopify range chaque ligne ajoutee EN TETE du panier : le produit reste ainsi
        la 1re ligne, comme aujourd'hui (checkout ?product=, e-mail de panier abandonne et commande lisent la 1re ligne non cadeau). */
  function isAddon(it) { var p = it && it.properties; return !!(p && (p._addon === 'true' || p._addon === true)); }
  function wrap(f) {
    if (typeof f !== 'function' || f.__pdeb) return f;
    var w = function (input, init) {
      try {
        var u = typeof input === 'string' ? input : ((input && input.url) || '');
        if (/\/cart\/add(\.js)?(\?|$)/.test(u) && init && typeof init.body === 'string') {
          var j = JSON.parse(init.body);
          if (j && Array.isArray(j.items)) {
            var add = j.items.filter(isAddon), rest = j.items.filter(function (it) { return !isAddon(it); });
            if (add.length && rest.length && j.items.indexOf(add[0]) > 0) {
              j.items = add.concat(rest);
              var i2 = {};
              for (var k in init) i2[k] = init[k];
              i2.body = JSON.stringify(j);
              return f.call(this, input, i2);
            }
          }
        }
      } catch (e) {}
      return f.apply(this, arguments);
    };
    w.__pdeb = 1;
    return w;
  }
  window.fetch = wrap(window.fetch);

  /* 2. Cases de l'option synchronisees (offre <-> bas de page) */
  function boxes() { return qa('input[data-pdeb-addon]'); }
  function addonOn() { return boxes().some(function (i) { return i.checked; }); }
  function setAddon(on) {
    boxes().forEach(function (i) {
      i.checked = on;
      var l = i.closest('.pdeb-add');
      if (l) l.classList.toggle('on', on);
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-pdeb-addon]')) return;
    setAddon(t.checked);
    ph('gift_addon_toggle', { on: t.checked, where: t.closest('.pdeb-cta,.pdx-cta,[id^="vs2cta-"]') ? 'bottom' : 'offer' });
  }, true);

  /* 3. Pop-up « Add to cart » : la pop-up de la fiche propose l'option (si elle n'est pas deja cochee) */
  var GIFT_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v7.2A1.8 1.8 0 0 0 6.8 21h10.4a1.8 1.8 0 0 0 1.8-1.8V12M12 8v13M12 8C10.8 5 8 3.6 6.9 5.1 5.9 6.6 8.4 8 12 8zm0 0c1.2-3 4-4.4 5.1-2.9 1 1.5-1.5 2.9-5.1 2.9z"/></svg>';
  var modal = null, pending = null, decided = false, openedAt = 0;
  /* 07/10 : un 2e tap trop rapide (double tap mobile sur « Ajouter ») tombait sur la pop-up qui venait de s'ouvrir et ajoutait l'option.
     Pendant 700 ms après l'ouverture, les taps sur « Yes » et sur l'encart sont ignorés. */
  function tooSoon() { return Date.now() - openedAt < 700; }
  function rebind(id, fn) {
    var b = document.getElementById(id);
    if (!b) return null;
    var c = b.cloneNode(true);                 /* le clone n'a plus les ecouteurs de la pop-up cadeau du theme */
    b.parentNode.replaceChild(c, b);
    c.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); fn(); });
    return c;
  }
  function fill() {
    modal = document.getElementById('FreeGiftModal');
    if (!modal || !A) return false;
    if (modal.getAttribute('data-pdeb')) return true;
    var pct = Math.round((1 - A.price / A.was) * 100);
    var ey = q('#FG1 .fg-eyebrow', modal), img = q('#FreeGiftImg', modal), tt = q('#FreeGiftTitle', modal),
        val = q('#FreeGiftValue', modal), bar = q('#FGBar', modal);
    if (ey) ey.innerHTML = '<span class="pdeb-ey">' + GIFT_SVG + '<span>ADD IT TO YOUR ORDER</span></span>';
    if (img) {
      img.src = A.img; img.alt = A.title; img.style.display = '';
      var w = document.createElement('span');
      w.className = 'pdeb-imgw';
      img.parentNode.insertBefore(w, img);
      w.appendChild(img);
      if (pct > 0) w.insertAdjacentHTML('beforeend', '<span class="pdeb-badge"><b>SAVE ' + pct + '%</b><i>LIMITED TIME</i></span>');
    }
    if (tt) tt.textContent = A.title;
    if (val) val.innerHTML = '<span class="pdeb-now">' + (A.price_fmt || money(A.price)) + '</span><s class="pdeb-was">' + (A.was_fmt || money(A.was)) + '</s>';
    if (bar) bar.style.display = 'none';
    var acc = rebind('FreeGiftAccept', function () { if (tooSoon()) return; finish(true); });
    var dec = rebind('FreeGiftDecline', function () { finish(false); });
    if (acc) acc.textContent = 'YES, ADD IT FOR ' + (A.price_fmt || money(A.price));
    /* 06/10 (validé) : l'encart de l'option (titre, image, nom, prix) est cliquable = « Yes, add it » (clics morts mesurés dessus) */
    var f1c = q('#FG1', modal);
    if (f1c && !f1c.__pdebCard) {
      f1c.__pdebCard = 1;
      f1c.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target : null;
        if (!t || t.closest('button, a, #FreeGiftAccept, #FreeGiftDecline')) return;
        if (!t.closest('.fg-eyebrow, .pdeb-imgw, #FreeGiftImg, #FreeGiftTitle, #FreeGiftValue')) return;
        if (tooSoon()) return;
        finish(true, 'accept_card');
      });
    }
    if (dec) dec.textContent = 'No thanks, continue';
    if (PDD !== 'a') design(acc, dec);
    modal.setAttribute('data-pdeb', '1');
    return true;
  }
  /* --- variantes de design (b, c) : même boutons, mêmes écouteurs, seule la présentation change --- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mainInfo() {
    var r = q('quantity-breaks-v2 input[name="quantity"]:checked'), card = r && r.nextElementSibling;
    var pe = card && q('.vs2-price-now', card), le = card && q('.vs2-label', card);
    var img = q('img.vs2-varthumb') || q('.product__media-item img') || q('.product__media img');
    return { price: pe ? pe.textContent.replace(/\s+/g, '').trim() : '', label: le ? le.textContent.trim() : '',
             img: img ? (img.currentSrc || img.getAttribute('src') || '') : '' };
  }
  function recap() {
    var box = q('.pdb-rc', modal); if (!box) return;
    var m = mainInfo(), num = parseFloat((m.price || '').replace(/[^0-9.]/g, ''));
    var pre = ((m.price || '').match(/^[^0-9]*/) || [''])[0] || '$';
    q('.pdb-main img', box).src = m.img || '';
    q('.pdb-main .t span', box).textContent = (m.label ? m.label + ' \u00B7 ' : '') + 'in your cart';
    q('.pdb-main .p', box).textContent = m.price;
    var tot = q('.pdb-tot', box);
    if (num > 0) { tot.style.display = ''; q('b', tot).textContent = pre + (num + A.price / 100).toFixed(2); } else tot.style.display = 'none';
  }
  function design(acc, dec) {
    modal.classList.add('pdeb-pd-' + PDD);
    var f1 = q('#FG1', modal), ey = q('.fg-eyebrow', f1), iw = q('.pdeb-imgw', f1), tt = q('#FreeGiftTitle', f1), val = q('#FreeGiftValue', f1), gp = q('.pdxb-pop', f1);
    var now = A.price_fmt || money(A.price), was = A.was_fmt || money(A.was), pct = Math.round((1 - A.price / A.was) * 100);
    var st = document.createElement('style');
    if (PDD === 'b') {
      if (ey) ey.innerHTML = '<span class="pdeb-ey">' + GIFT_SVG + '<span>COMPLETE YOUR ORDER</span></span>';
      f1.insertBefore(document.createRange().createContextualFragment(
        '<div class="pdb-rc">'
        + '<div class="pdb-row pdb-main"><img alt=""><div class="t"><b>' + esc(D.brand || '') + '</b><span></span></div><span class="p"></span><span class="ok" aria-hidden="true">&#10003;</span></div>'
        + '<div class="pdb-row pdb-add"><img alt="" src="' + esc(A.img) + '"><div class="t"><b>' + esc(A.title) + '</b><span>' + (pct > 0 ? 'Save ' + pct + '% with your order' : 'Add it to your order') + '</span></div>'
        + '<span class="p"><b>' + esc(now) + '</b><s>' + esc(was) + '</s></span></div>'
        + (N ? '<div class="pdb-gd">+ ' + N + ' free ' + W + ' by email, included</div>' : '')
        + '<div class="pdb-tot"><span>Total with ' + esc(A.title) + '</span><b></b></div></div>'), ey ? ey.nextSibling : f1.firstChild);
      if (acc) acc.textContent = 'YES, ADD IT \u00B7 +' + now;
      if (dec) dec.textContent = 'Continue without it';
      st.textContent = '#FreeGiftModal.pdeb-pd-b .pdeb-imgw,#FreeGiftModal.pdeb-pd-b #FreeGiftTitle,#FreeGiftModal.pdeb-pd-b #FreeGiftValue,#FreeGiftModal.pdeb-pd-b .pdxb-pop{display:none!important}'
        + '.pdb-rc{display:flex;flex-direction:column;gap:8px;margin:14px 0 14px;text-align:left}'
        + '.pdb-row{display:flex;align-items:center;gap:10px;border:1px solid #e5e5e5;border-radius:12px;padding:8px 10px;background:#fff}'
        + '.pdb-row img{width:48px;height:48px;object-fit:contain;border-radius:8px;background:#f6f6f6;flex:none}'
        + '.pdb-row .t{flex:1;min-width:0;display:flex;flex-direction:column;line-height:1.25}.pdb-row .t b{font-size:14.5px;color:#111;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}'
        + '.pdb-row .t span{font-size:12.5px;color:#6b7280}.pdb-row .p{font-weight:700;font-size:14.5px;color:#111;white-space:nowrap;display:flex;flex-direction:column;align-items:flex-end;line-height:1.2}'
        + '.pdb-row .p s{font-weight:400;font-size:12px;color:#888}.pdb-main .ok{width:20px;height:20px;border-radius:50%;background:#16a34a;color:#fff;font-size:12px;display:flex;align-items:center;justify-content:center;flex:none}'
        + '.pdb-main{background:#f8faf8}.pdb-add{border:2px dashed #16a34a;background:#f0fdf4}.pdb-add .p b{color:#ac123b;font-size:16px}'
        + '.pdb-gd{font-size:12.5px;color:#15803d;font-weight:600;padding:0 4px}'
        + '.pdb-tot{display:flex;justify-content:space-between;align-items:baseline;border-top:1px solid #e5e5e5;padding:8px 4px 0;font-size:13.5px;color:#374151}.pdb-tot b{font-size:16px;color:#111}';
    } else if (PDD === 'c') {
      var row = document.createElement('div'); row.className = 'pdc-row';
      var tx = document.createElement('div'); tx.className = 'pdc-tx';
      if (iw) row.appendChild(iw);
      if (ey) { ey.innerHTML = '<span class="pdeb-ey">' + GIFT_SVG + '<span>ADD TO YOUR ORDER</span></span>'; tx.appendChild(ey); }
      if (tt) tx.appendChild(tt);
      if (val) tx.appendChild(val);
      row.appendChild(tx);
      f1.insertBefore(row, f1.firstChild);
      var bt = document.createElement('div'); bt.className = 'pdc-btns';
      if (dec) bt.appendChild(dec);
      if (acc) bt.appendChild(acc);
      f1.appendChild(bt);
      if (acc) acc.textContent = 'ADD IT \u00B7 ' + now;
      if (dec) dec.textContent = 'No thanks';
      st.textContent = '#FreeGiftModal.pdeb-pd-c{align-items:flex-end!important;justify-content:center!important}'
        + '#FreeGiftModal.pdeb-pd-c .fg-box{width:100%!important;max-width:520px!important;border-radius:18px 18px 0 0!important;margin:0!important;padding:16px 16px calc(16px + env(safe-area-inset-bottom,0px))!important;animation:pdcUp .22s ease-out}'
        + '@keyframes pdcUp{from{transform:translateY(40px);opacity:.4}to{transform:none;opacity:1}}'
        + '#FreeGiftModal.pdeb-pd-c #FG1{text-align:left!important}'
        + '.pdc-row{display:flex;align-items:center;gap:14px}.pdc-tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}'
        + '#FreeGiftModal.pdeb-pd-c .pdeb-imgw{width:88px!important;margin:6px 0 0 6px!important;flex:none}'
        + '#FreeGiftModal.pdeb-pd-c .pdeb-badge{top:-8px!important;left:-10px!important;transform:scale(.78);transform-origin:top left}'
        + '#FreeGiftModal.pdeb-pd-c .fg-eyebrow{margin:0!important;text-align:left!important;justify-content:flex-start;font-size:12px!important}'
        + '#FreeGiftModal.pdeb-pd-c #FreeGiftTitle{margin:0!important;text-align:left!important;font-size:17px!important}'
        + '#FreeGiftModal.pdeb-pd-c #FreeGiftValue{justify-content:flex-start!important;margin:0!important}'
        + '#FreeGiftModal.pdeb-pd-c .pdxb-pop{margin:12px 0 0!important;font-size:12.5px!important}'
        + '.pdc-btns{display:flex;gap:10px;margin-top:14px}'
        + '#FreeGiftModal.pdeb-pd-c .pdc-btns button{flex:1;margin:0!important;width:auto!important;min-height:50px;border-radius:12px!important;font-size:15px!important}'
        + '#FreeGiftModal.pdeb-pd-c #FreeGiftDecline{flex:0 0 38%;background:#fff!important;border:1.5px solid #d1d5db!important;color:#374151!important;text-decoration:none!important;font-weight:600!important}';
    }
    document.head.appendChild(st);
  }
  function close() { if (modal) modal.style.display = 'none'; }
  function finish(withAddon, how) {
    setAddon(withAddon);
    decided = true;
    close();
    ph('gift_addon_popup', { action: how || (withAddon ? 'accept' : 'decline'), design: PDD });
    if (pending) pending.click();               /* buy-buttons-v2 : panier (produit + option cochee, sans cadeau) puis checkout */
  }
  function open(btn) {
    if (!fill()) return false;
    pending = btn;
    var f1 = q('#FG1', modal), f2 = q('#FG2', modal);
    if (f1) f1.style.display = 'block';
    if (f2) f2.style.display = 'none';
    if (typeof window.pdPrewarm === 'function') { try { window.pdPrewarm(); } catch (e) {} }   /* comme la pop-up d'aujourd'hui */
    if (PDD === 'b') recap();
    openedAt = Date.now();
    modal.style.display = 'flex';
    ph('gift_addon_popup', { action: 'shown', design: PDD });
    return true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[id^="ProductSubmitButton-"]') : null;
    if (!b || b.disabled) return;
    if (decided) { decided = false; return; }  /* clic relance par la pop-up : on laisse passer */
    if (!A || addonOn()) return;                /* option deja cochee : panier direct */
    if (POP === 'off') return;                  /* test A/B (07/10) : pas de pop-up, panier direct */
    if (window.__pdIncFree) return;             /* test inc (07/10) : option offerte en Buy 2+, rien a proposer */
    if (!open(b)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
  /* 05/10 (validé) : taper a cote de la pop-up = « No thanks » + checkout (avant : la pop-up se fermait et 94 % de ces visiteurs
     ne revenaient pas, mesure PostHog 04-05/10). Evenement action = 'dismiss' pour le distinguer d'un vrai « non ». */
  document.addEventListener('click', function (e) {
    if (modal && e.target === modal && pending && !decided && !tooSoon()) finish(false, 'dismiss');
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { decided = false; pending = null; close(); } });

  /* 4. Le reste de la page : guides a la place du cadeau */
  function rest() {
    var cta = q('[id^="vs2cta-"] .vx-sb'), tpl = q('#pdeb-cta-tpl');
    if (cta && tpl && !q('.pdeb-cta')) cta.insertAdjacentHTML('afterend', tpl.innerHTML);
    var inc = q('.pdx-inc-box'), atpl = q('#pdeb-add-tpl');
    if (inc && atpl && !q('.pdx-inc-box + .pdeb-addwrap')) inc.insertAdjacentHTML('afterend', atpl.innerHTML);
    /* pdx, CTA final : la ligne guides de « What's included » prend le style de l'ancienne ligne cadeau (comme dans les offres) */
    qa('.pdx-inc-box .pdx-inc-row--bk').forEach(function (r) {
      if (r.classList.contains('pdeb-c')) return;
      r.classList.add('pdeb-c');
      var eb = q('.pdx-inc-eb', r), see = q('.pdx-inc-see', r);
      if (eb) eb.textContent = '+ ' + N + ' free ' + W;
      r.insertAdjacentHTML('beforeend', '<span class="pdeb-rcol"><span class="pdx-gift-pr"><s>' + (D.value_fmt || ('$' + (+D.value || N * 9))) + '</s><b class="pdx-free">FREE</b></span></span>');
      if (see) q('.pdeb-rcol', r).appendChild(see);
    });
    qa('.pdx-chip span').forEach(function (s) { if (/free gift/i.test(s.textContent)) s.textContent = N + ' free ' + W + ' included'; });
    qa('sticky-atc .vx-sk--giftshort').forEach(function (s) {
      var svg = s.querySelector('svg');
      s.textContent = N + ' free ' + W + ' included';
      if (svg) s.insertBefore(svg, s.firstChild);
    });
    var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), t;
    while ((t = tw.nextNode())) {
      if (/with your free gift included/i.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/with your free gift included/i, 'with ' + N + ' free expert ' + W + ' included');
    }
    setAddon(addonOn());
    html.classList.add('pdeb-ready');
  }
  /* 06/10 (validé) : taper sur les couvertures ou le nom des guides ouvre l'aperçu « See inside » (clics rageurs mesurés sur les couvertures) */
  try {
    var st = document.createElement('style');
    st.textContent = 'html.pdeb .pdeb-fan,html.pdeb .pdeb-tx,#FreeGiftModal[data-pdeb] .fg-eyebrow,#FreeGiftModal[data-pdeb] .pdeb-imgw,#FreeGiftModal[data-pdeb] #FreeGiftTitle,#FreeGiftModal[data-pdeb] #FreeGiftValue{cursor:pointer}';
    document.head.appendChild(st);
  } catch (e) {}
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.pdeb-fan, .pdeb-tx') : null;
    if (!t) return;
    var row = t.closest('.pdeb-bonus'), see = row && row.querySelector('.pdeb-see');
    if (!see) return;
    e.preventDefault();
    see.click();
    ph('guides_cover_tap', {});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rest); else rest();
  /* la barre collante du theme construit ses pastilles apres le chargement : on repasse une fois */
  window.addEventListener('load', function () { setTimeout(rest, 600); });
})();
